import { render } from "./ModalViewImg.vue?vue&type=template&id=1f0c743c"
import script from "./ModalViewImg.vue?vue&type=script&lang=js"
export * from "./ModalViewImg.vue?vue&type=script&lang=js"

import "./ModalViewImg.vue?vue&type=style&index=0&id=1f0c743c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__